<template>
  <div class="bg-white shadow-md rounded-lg overflow-hidden">
    <h2 class="text-2xl font-bold mb-4 px-6 py-4 bg-gray-50">Patienten</h2>
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nachname</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vorname</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Titel</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Geburtsdatum</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">KVNR</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Straße</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PLZ</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ort</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Geschlecht</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="patient in patients" :key="patient.easytiUUID" @click="selectPatient(patient)" class="hover:bg-gray-50 cursor-pointer">
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ patient.surname }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ patient.givenName }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ patient.title }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(patient.dateOfBirth) }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ patient.insurantId }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ `${patient.streetAddress.street} ${patient.streetAddress.houseNumber}` }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ patient.streetAddress.postcode }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ patient.streetAddress.city }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ getGenderInGerman(patient.gender) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <MusterModal v-if="showMusterModal" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useDbStore } from '../stores/dbStore';
import MusterModal from './MusterModal.vue';

export default {
  name: 'PatientTable',
  components: {
    MusterModal
  },
  setup() {
    const dbStore = useDbStore();

    const patients = computed(() => dbStore.patients);
    const showMusterModal = computed(() => dbStore.getShowMusterModal);

    const selectPatient = (patient) => {
      dbStore.setSelectedPatient(patient.easytiUUID);
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    };

    const getGenderInGerman = (gender) => {
      if (gender === 'FEMALE') {
        return 'Weiblich';
      } else if (gender === 'MALE') {
        return 'Männlich';
      }
      return gender;
    };

    return {
      patients,
      selectPatient,
      showMusterModal,
      formatDate,
      getGenderInGerman,
    };
  }
}
</script>